/**
 * US ZIP-code search — `GET /v2/zip-codes/?search=`.
 *
 * Backs the Facility Schedule "Zip" autocomplete (OR-881 / OR-1362). The
 * backend matches `search` as a prefix over the ZIP and returns the ZIP's
 * geography; picking one auto-fills city / state / county (FIPS) / geo
 * (urbanicity) on the row — fixing "county not populated". County is stored
 * as a FIPS code (Henry: "county = fips"), same as the facility catalog.
 */
import { getJsonReal } from "../client";

export interface ZipCode {
    zipCode: string;
    city: string | null;
    state: string | null;
    /** County FIPS code — what the Schedule County field stores. */
    fips: string | null;
    /** County name — shown in the dropdown option. */
    county: string | null;
    /** "Urban" | "Rural" — maps to the Schedule Geo column. */
    urbanicity: string | null;
}

interface ZipCodeWire {
    zip_code: string;
    city: string | null;
    state: string | null;
    fips: string | null;
    county: string | null;
    urbanicity: string | null;
}

interface ZipCodesListWire {
    total: number;
    items: ZipCodeWire[];
}

function toZipCode(z: ZipCodeWire): ZipCode {
    return {
        zipCode: z.zip_code,
        city: z.city ?? null,
        state: z.state ?? null,
        fips: z.fips ?? null,
        county: z.county ?? null,
        urbanicity: z.urbanicity ?? null,
    };
}

export function searchZipCodes(search: string, limit = 8): Promise<ZipCode[]> {
    const qs = new URLSearchParams({ search, limit: String(limit) });
    return getJsonReal<ZipCodesListWire>(`/v2/zip-codes/?${qs.toString()}`).then((res) => res.items.map(toZipCode));
}
